import { gql } from 'graphql-request';

export default gql`
  mutation phoneNumberDelete($data: JSON) {
    phoneNumberDelete(data: $data) {
      success
      message
      data
    }
  }
`;
